import { Component, OnInit } from '@angular/core';
import { Orcamento } from 'src/app/admihair/api/dto/orcamento';
import { AdmihairBaseComponent } from '../../../admihair-base.component';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { OrcamentoService } from 'src/app/admihair/service/orcamento.service';
import { ItemOrcamento } from 'src/app/admihair/api/dto/item-orcamento';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-orcamentos-e-pacotes-detalhar',
  templateUrl: './orcamentos-e-pacotes-detalhar.component.html',
  styleUrls: ['./orcamentos-e-pacotes-detalhar.component.scss']
})
export class OrcamentosEPacotesDetalharComponent extends AdmihairBaseComponent implements OnInit {

  id?: number;
  orcamento?: Orcamento;
  itensOrcamento: ItemOrcamento[] = [];
  valorTotalItens: number = 0;

  constructor(private orcamentoService: OrcamentoService,
    private _activatedRoute: ActivatedRoute,
    erroService: ErroService,
    storageService: UtilStorageService) {
    super(erroService,storageService);
   }

  ngOnInit(): void {
    this.setExibirSpinnerPrincipal(true);
    this.permissaoDetalhar = this.verificarPermissao('PERM_DETALHAR_ORCAMENTOS_E_PACOTES');
    this.carregarIdOrcamento();
    if (this.permissaoDetalhar) {
      this.carregarOrcamento();
    }
  }

  carregarOrcamento() {
    this.orcamentoService.buscarPorId(this.id).subscribe({
      next: (data: Orcamento) => {
        console.log(data)
        this.orcamento = data;
        this.itensOrcamento = data.listaItens ?? [];
        this.calcularValorTotal();
        this.setExibirSpinnerPrincipal(false);
      },
      error: (err: any) => {
        this.setExibirSpinnerPrincipal(false);
        this.exibirMensagemErro(err);
      }
    })
  }

  carregarIdOrcamento(){
    const idParam = this._activatedRoute.snapshot.paramMap.get('id');
    if(idParam){
      this.id = parseInt(idParam);
    }
  }


  calcularValorTotal() {
    this.valorTotalItens = 0;
    for(let item of this.itensOrcamento) {
      this.valorTotalItens += this.calcularValorTotalItem(item);
    }
    this.calcularValorProposta();
  }

  calcularValorTotalItem(item: ItemOrcamento): number {
    const desconto = item.descontoItem ?? 0;
    const quantidade = item.quantidadeProposta ?? 1;
    const valorUnitario = item.valorUnitario ?? 0;

    const valorComDesconto = valorUnitario - (valorUnitario * (desconto / 100));
    return valorComDesconto * quantidade;
  }

  calcularValorProposta(){
    
    if(this.orcamento?.valorProposta){
      let valorPropostaCalculado = 0;
      const descontoAplicado = (this.orcamento.desconto ?? 0) / 100;
      valorPropostaCalculado += this.valorTotalItens - (this.valorTotalItens * descontoAplicado);
      this.orcamento.valorProposta = valorPropostaCalculado;
    }
  }

}
